module.exports = __webpack_public_path__ + "img/andrew.f8f35708.jpg";